class ScrollingMarquee extends HTMLElement {
  connectedCallback() {
    this.#observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('is-active', entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );

    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  /** @type {IntersectionObserver | null} */
  #observer = null;
}

if (!customElements.get('scrolling-marquee')) {
  customElements.define('scrolling-marquee', ScrollingMarquee);
}
